import type { DataSetContext as DataSetContextType } from '../types.ts';
import { useIPO } from './useIPO.ts';

export default (): DataSetContextType => {
    const { dataset } = useIPO();

    return dataset;
};
